import { render, staticRenderFns } from "./PropostaGarantia.vue?vue&type=template&id=2efb6d61"
import script from "./PropostaGarantia.vue?vue&type=script&lang=js"
export * from "./PropostaGarantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports